import { render, staticRenderFns } from "./FileDistribution.vue?vue&type=template&id=6efd07a6&scoped=true"
import script from "./FileDistribution.vue?vue&type=script&lang=js"
export * from "./FileDistribution.vue?vue&type=script&lang=js"
import style0 from "./FileDistribution.vue?vue&type=style&index=0&id=6efd07a6&prod&scoped=true&lang=css"
import style1 from "./FileDistribution.vue?vue&type=style&index=1&id=6efd07a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd07a6",
  null
  
)

export default component.exports